export default __webpack_public_path__ + "static/vegetableroll-8eaf6b5e0a52e573d82551c4355dc0b5.png";